import { type ReactElement } from 'react';

import styles from './stages-table.module.scss';
import { Font } from '@utmb/design-system/text/font';
import { PiCategoryLogo } from '@utmb/design-system/pi-category-logo/PiCategoryLogo';
import { usePreference } from '@utmb/contexts/PreferenceContext';
import { formatUnit } from '@utmb/utils/unit';
import RaceYearResultStageView from '@utmb/types/view/RaceYearResultStageView';

export interface StagesTableProps {
    stages: RaceYearResultStageView[];
}

// Shared content of the "X Stages" popover: one row per stage with its number,
// category, distance and elevation gain. Rendered both in the desktop hover
// tooltip and the mobile click popover of PalmaresRow.
export function StagesTable({ stages }: StagesTableProps): ReactElement {
    const {
        preferences: { preferredUnit },
    } = usePreference();

    return (
        <div className={styles.stagesTable}>
            <table className={styles.table}>
                <tbody>
                    {stages.map((stage, i) => (
                        <tr key={i}>
                            <td>
                                <Font.FuturaMedium as="span" desktop="16" mobile="14">
                                    {String(i + 1).padStart(2, '0')}
                                </Font.FuturaMedium>
                            </td>
                            <td className={styles.category}>
                                {stage.piCategory ? (
                                    <PiCategoryLogo height={12} piCategory={stage.piCategory} isDark={false} />
                                ) : (
                                    <Font.FuturaBook as="span" desktop="14" mobile="12">
                                        —
                                    </Font.FuturaBook>
                                )}
                            </td>
                            <td>
                                <Font.FuturaMedium as="span" desktop="16" mobile="14">
                                    {stage.distance ? formatUnit(preferredUnit, 'distance', Number(stage.distance)) : '—'}
                                </Font.FuturaMedium>
                            </td>
                            <td>
                                <Font.FuturaBook className={styles.elevation} as="span" desktop="16" mobile="14">
                                    {stage.elevationGain ? formatUnit(preferredUnit, 'elevationGain', Number(stage.elevationGain)) : '—'}
                                </Font.FuturaBook>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
